import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const DataValidationMessageBar = ({ validationErrors }) => {
  const { t } = useTranslation();
  return (
    <MessageBar intent="error" style={{ alignItems: "flex-start", marginTop: "1.5rem", padding: "0.5rem" }}>
      <MessageBarBody>
        <MessageBarTitle>
          {t("nounPhrases.dataMissingOrIncorrect")} ({Object.keys(validationErrors).length})
        </MessageBarTitle>
        {Object.entries(validationErrors).map(([key, value]) => (
          <div key={key}>{key === "unknown" ? t("nounPhrases.errorUnknown") : value}</div>
        ))}
      </MessageBarBody>
    </MessageBar>
  );
};

export default DataValidationMessageBar;
